import images from "../../assets/images/assets";
import ProductCard from "../SmallComponents/ProductCard";
import SectionHeader1 from "../SmallComponents/SectionHeader1";
import { ShopContext } from "../Context/ShopContext";
// Import Data-Frontend Dummy Data
// import { productsData } from "../../assets/data/data";
import { useContext } from "react";

const OurCollection = () => {
  // Products from Backend
  const { products } = useContext(ShopContext);
  // console.log("All products from context:", products);

  // Get latest 4 products
  const latestProducts = [...products]
    .sort((a, b) => b.createdAt - a.createdAt) //Sort by latest
    .slice(0, 4); // Take only 4

  // console.log("Latest products to be rendered:", latestProducts);

  return (
    <div className="bg-transparent w-full p-4  relative">
      <div className="bg-transparent py-5 lg:px-4">
        <SectionHeader1 title=" Discover our new collection" />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-2 mt-8 lg:my-14 lg:mt-20 ">
          {latestProducts.map((product) => {
            // console.log("Rendering product:", product);
            return (
              <ProductCard
                key={product._id}
                name={product.name}
                price={product.price}
                _id={product._id}
                cover={product.images[0]}
              />
            );
          })}
        </div>
      </div>

      {/* Decorative */}
      <img
        src={images.blur_2}
        alt="blur"
        className="absolute -right-38 md:-right-64 -bottom-10 md:-bottom-26 mirror-x saturate-200 lg:-right-90 lg:-bottom-96"
      />
    </div>
  );
};

export default OurCollection;
